# import BalanceFragment from "../fragments/balance.graphql"

query GetRevenue($company_id: ID!) {
  revenue(company_id: $company_id) {
    ...BalanceFragment
  }
}
